import { createAction } from '@reduxjs/toolkit'

/**
 * Команды журнала чеков — plain actions (F05). UI вызывает actions binding-а,
 * binding dispatch-ит команду, listener исполняет её. Reducer команду не
 * обрабатывает: запросы живут в listener, не в reducer (D-063).
 */

/** Перечитать журнал ресурса (страницы, кассы, смены, статус сверки). */
export const receiptsReloadRequested = createAction<{ resourceId: string }>('aqsi/receipts/reloadRequested')

/**
 * Поставить сверку журнала. `operationId` и ключ создаёт binding ОДИН раз на
 * намерение человека — повтор той же команды сервер узнаёт по ним.
 */
export const journalSyncRequested = createAction<{ resourceId: string; operationId: string; idempotencyKey: string }>(
  'aqsi/receipts/journalSyncRequested',
)
